<template>
    <div>
        <game-rule-search-bar-component
            AddAuth="新增游戏规则"
            :AllState="AllState"
            :AllType="AllType"
            :AllCircumstances="AllCircumstances"
            @search="get_game_rule_index"
            @addTeam="addTeam"
        ></game-rule-search-bar-component>
        <el-card class="box_card" v-loading.fullscreen.lock="loading">
            <el-table
                :data="table_data"
                style="width: 100%"
                border
                stripe
                highlight-current-row
            >
                <el-table-column
                    align="center"
                    type="index"
                    min-width="10px">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="state"
                    label="状态"
                    min-width="70px"
                >
                    <template slot-scope="scope">
                        <el-tag size="small" type="info" v-if="scope.row.state === 0">移除</el-tag>
                        <el-tag size="small" type="success" v-else-if="scope.row.state === 1">正常</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="name"
                    label="规则名称"
                    min-width="90px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.type === 1" style="color: #CE0000;font-weight: bold;">{{ scope.row.name }}</span>
                        <span v-else-if="scope.row.type === 2" style="color: #D9B300;font-weight: bold;">{{ scope.row.name }}</span>
                        <span v-else-if="scope.row.type === 3" style="color: #0080FF;font-weight: bold;">{{ scope.row.name }}</span>
                        <span v-else-if="scope.row.type === 4" style="color: #00A600;font-weight: bold;">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="content"
                    label="规则内容"
                    min-width="500px"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.content }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="circumstances"
                    label="生效场景"
                    min-width="180px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.circumstances ===0">无限制</span>
                        <span v-else-if="scope.row.circumstances ===1">5人以上身份场</span>
                        <span v-else-if="scope.row.circumstances ===2">7人以上身份场</span>
                        <span v-else-if="scope.row.circumstances ===3">8人身份场</span>
                        <span v-else-if="scope.row.circumstances ===4">全角色场</span>
                        <span v-else-if="scope.row.circumstances ===5">6人或8人身份全角色场</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="详情"
                    min-width="70px"
                >
                    <template slot-scope="scope">
                        <el-button @click="details_game_rule(scope.row.id)" size="mini">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="total"
            @search="get_game_rule_index"
        ></common-page-component>
        <game-rule-edit-component
            edit_auth="修改游戏规则"
            del_auth="删除游戏规则"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :game_rule_details_data="fgame_rule_details_data"
            :AllState="AllState"
            :AllType="AllType"
            :AllCircumstances="AllCircumstances"
            @exitGameRuleDialog="dialogExit"
            @search="get_game_rule_index"
            @show_edit="show_edit"
            @cancel_edit="cancel_edit"
            @details_row="details_game_rule"
        ></game-rule-edit-component>
    </div>
</template>

<script>
import { GameRuleIndexRequest,GameRuleDetailsRequest } from '@/network/card/GameRule.js'

import GameRuleSearchBarComponent from '@/components/card/GameRule/GameRuleSearchBarComponent'
import GameRuleEditComponent from '@/components/card/GameRule/GameRuleEditComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'

export default {
    name:'',
    data(){
        return {
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: true,
            total: 0,
            cond: {
                state: '',
                name: '',
                type: '',
                page: 1,
                limit: 10
            },
            table_data: [],
            fgame_rule_details_data: {},
            AllState: [
                {id: 0,name: '移除'},
                {id: 1,name: '正常'}
            ],
            AllType: [
                {id: 1,name: '红色'},
                {id: 2,name: '黄色'},
                {id: 3,name: '蓝色'},
                {id: 4,name: '绿色'}
            ],
            AllCircumstances: [
                {id: 0,name: '无限制'},
                {id: 1,name: '5人以上身份场'},
                {id: 2,name: '7人以上身份场'},
                {id: 3,name: '8人身份场'},
                {id: 4,name: '全角色场'},
                {id: 5,name: '6人或8人身份全角色场'}
            ]
        }
    },
    computed:{},
    methods:{
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        cancel_edit() {
            this.edit_type = 0
        },
        get_game_rule_index(param = {}) {
            this.loading = true
            this.cond.state = param.state ?? this.cond.state
            this.cond.name = param.name ?? this.cond.name
            this.cond.type = param.type ?? this.cond.type
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            GameRuleIndexRequest(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.table_data = s.result.data
                        this.total = s.result.total
                        
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
                .finally()
        },
        details_game_rule(id) {
            this.fid = id
            this.fdialogFormVisible = true
            GameRuleDetailsRequest(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.fgame_rule_details_data = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        }
    },
    filters:{},
    props:{},
    created(){
        this.get_game_rule_index()
    },
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{
        GameRuleSearchBarComponent,
        GameRuleEditComponent,
        CommonPageComponent
    },
    watch:{},
}
</script>

<style lang='less' scoped></style>